var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"tool",attrs:{"id":"layer-info"}},[_c('h3',[_vm._v(_vm._s(_vm.layer.metadata.name))]),_c('p',[_vm._v("Description de la couche "),_c('i',[_vm._v(_vm._s(_vm.layer.metadata.name))]),_vm._v(" "+_vm._s(_vm.layer.metadata.description))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }